const COMMON_SIZES = {
    MOBILE_TABLET_DESKTOP:
        '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px'
};

export const sizesPredef = {
    web_xxss: { default: '(max-width: 2256px) 100vw, 2256px' },
    web_destacat: {
        default: COMMON_SIZES.MOBILE_TABLET_DESKTOP,
        2: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 2), 188px',
        3: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 3), 300px',
        4: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 4), 400px',
        6: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 6), 600px',
        8: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 8), 800px',
        9: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 9), 900px',
        12: COMMON_SIZES.MOBILE_TABLET_DESKTOP
    },
    web_destacat_horitzontal: '(max-width: 670px) calc(100vw - 32px), (max-width: 1920px) calc((100vw - 112px) / 3.7), 534px',
    web_poster_horitzontal: {
        default:
            '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px',
        2: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 2), 188px',
        3: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 3), 300px',
        4: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 4), 400px',
        6: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 6), 600px',
        8: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 8), 800px',
        9: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 9), 900px',
        12: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px'
    },
    web_poster_vertical: {
        default:
            '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px',
        2: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 2), 188px',
        3: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 3), 300px',
        4: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 4), 400px',
        6: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 6), 600px',
        8: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 8), 800px',
        9: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 9), 900px',
        12: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px'
    }, // TODO -- Un cop tinguem la imatge real del poster vertical dels butlletins definit els breakpoints
    web_cercador: {
        default:
            '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px',
        2: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 2), 188px',
        3: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 3), 300px',
        4: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 4), 400px',
        6: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 6), 600px',
        8: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 8), 800px',
        9: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 9), 900px',
        12: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px'
    },
    web_carrussel: '(max-width: 1919px) calc((100vw - 176px), 1440px'
};

export const cropPredef = {
    web_poster_vertical: '337x690',
    web_poster_horitzontal: '1903',
    web_destacat_horitzontal: '670x378',
    web_destacat: '1903',
    web_carrussel: '1440x810',
    web_graella: '326x184',
    web_cercador: '1903',
    web_xxss: '1920x1080'
};
export const tipusPredef = {
    web_poster_vertical: [{ rel_name: 'IMG_POSTER', mida: 'MASTER' }],
    web_poster_horitzontal: [{ rel_name: 'IMATGE_169', mida: 'MASTER' }],
    web_destacat_horitzontal: [
        { rel_name: 'IMAGE', mida: 'MASTER' },
        { rel_name: 'imatge_169', mida: 'MASTER' },
        { rel_name: 'IMATGE_169', mida: 'MASTER' },
        { rel_name: 'img_169_ct', mida: 'MASTER' },
        { rel_name: 'IMG_169_CT', mida: 'MASTER' },
        { rel_name: 'KEYVIDEO', mida: 'MASTER' },
        { rel_name: 'keyvideo', mida: 'MASTER' },
        { mida: '670x378' },
        { mida: '326x184' }
    ],
    web_cercador: [
        { rel_name: 'IMATGE_169', mida: 'MASTER' },
        { mida: '670x378' },
        { rel_name: 'IMATGE', mida: 'MASTER' },
        { rel_name: 'IMAGE', mida: 'MASTER' },
        { rel_name: 'KEYVIDEO', mida: 'MASTER' },
        { mida: '326x184' },
        { mida: 'mitjana' }
    ],
    web_destacat: [
        { rel_name: 'IMAGE', mida: 'MASTER' },
        { rel_name: 'image', mida: 'MASTER' },
        { rel_name: 'IMATGE_169', mida: 'MASTER' },
        { rel_name: 'imatge_169', mida: 'MASTER' },
        { rel_name: 'IMG_169_CT', mida: 'MASTER' },
        { rel_name: 'img_169_ct', mida: 'MASTER' },
        { rel_name: 'KEYVIDEO', mida: 'MASTER' },
        { rel_name: 'keyvideo', mida: 'MASTER' },
        { mida: 'MASTER' },
        { mida: '1920x1080' },
        { mida: '1200x677' },
        { mida: '1024x576' },
        { mida: '670x378' },
        { mida: '326x184' }
    ],
    web_carrussel: [
        { rel_name: 'IMATGE_169', mida: 'MASTER' },
        { rel_name: 'imatge_169', mida: 'MASTER' },
        { rel_name: 'KEYVIDEO', mida: 'MASTER' },
        { rel_name: 'keyvideo', mida: 'MASTER' },
        { mida: '1920x1080' },
        { mida: '1200x677' },
        { mida: '1400x500' },
        { mida: '1024x576' },
        { mida: '1014x570' },
        { mida: '670x378' },
        { mida: '650x350' },
        { mida: '326x184' }
    ],
    web_xxss: [{ mida: 'MASTER' }, { mida: 'XS' }],
    web_graella: [
        { rel_name: 'IMAGE', mida: '326x184' },
        { rel_name: 'IMAGE', mida: 'MASTER' }
    ]
};
